import { ProviderType } from "@redotech/redo-integrations-definitions-common/integration/integration-schema-definition";
import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const GLOBALE_PROVIDER_TYPES = [
  ProviderType.Refund,
  ProviderType.Shipping,
  ProviderType.ReturnSync,
] as const;

export const GLOBALE_DEFAULT_RETURN_SHIPPING_METHOD_ID = 10_006_402;

const optionalCredential = z
  .string()
  .trim()
  .transform((value) => value || undefined)
  .optional();

export const globaleSettings = defineIntegrationSettings({
  fields: {
    provides: z.array(z.enum(GLOBALE_PROVIDER_TYPES)),
    returnShippingMethodId: z
      .number()
      .int()
      .positive("Return shipping method ID must be a positive integer"),
    providerCode: z.string().trim().min(1, "Provider code is required"),
  },
  secrets: {},
  connectOnly: {
    apiDomain: z.string().trim().min(1, "API domain is required"),
    username: optionalCredential,
    password: z
      .string()
      .transform((value) => value || undefined)
      .optional(),
    GUID: optionalCredential,
  },
  computed: { apiDomain: z.string(), username: z.string().nullable() },
});
